/**
 * file : MyPage/List/Add.jsx
 * 설명 : 마이 페이지 > 문의하기 작성 페이지
 */

import { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { Insert } from "components/Common/ApiCall";
import { Spinner, Select, DropFileZone, Input } from "components/Common/Componentization";
import { useNavigate } from 'react-router-dom';

import logo from "assets/images/profile_img.jpg";          


export default function Add() {
  
  document.title = '문의요청'
  // 경로 지정 
  const navigate = useNavigate();
  // 입력 값
  const [value, setValue] = useState({
    images: []
  });
  const valInsert = (key, val) => { setValue({ ...value, [key]: val }) };
  const [dataLoading, setDataLoading] = useState(false);
  const common = useSelector(state => state.Common);

  return(
    <>
      <Spinner show={dataLoading} />
      {/* 스타일 시작 */}
      <div className="mypage_wrap">
        <div className="location">
          MY PAGE &nbsp; &gt; &nbsp; 나의 정보 &nbsp; &gt; &nbsp; 문의하기
			  </div>
        {/* 상단 모양 */}
        <div className="my_page_intor">
          <h2 className="font_style1">pongpong777</h2>
          <p className="font_style1">date 2024.03.24</p>
          <div className="profile_img">
            <img src={logo} alt="logo" />
          </div> 
        </div>
        {/* 탭 기능 */}
        <div className="mypage_content box_style1">
          <div className="tit">
            <h2>문의하기</h2>
          </div>
          <div className="tab_mu">
            <div className="tab box_style1">
              <ul>
                <li onClick={() => navigate("/myPage/tournamentRequest")}>
                  토너먼트 신청내역
                </li>
                <li onClick={() => navigate("/myPage/Message")}>
                  쪽지함
                </li>
                <li onClick={() => navigate("/myPage/inquery")} className="active">
                  문의하기
                </li>
              </ul>
            </div>
          </div>
          <div className="write_box">
            <p>표시는 필수 입력 항목 입니다.</p>
            <form action="">
              <div className="select_box">
                <Select elementKey="type" placeholder="✻ 문의 유형 선택" options={common.commons.board_type} selected={value} insert={valInsert} />
                <div>
                  <Input elementKey="betting_number" placeholder="베팅 번호" inputStyle="input-type" insert={valInsert} />
                </div>
                <div>
                  <Input elementKey="period_at" placeholder="발생 시기" inputStyle="input-type" insert={valInsert} />
                </div>
              </div>
              <div className="tit_box">
                <Input elementKey="title" placeholder="제목" inputStyle="input-type" insert={valInsert} />
              </div>
              <div className="input_textaea">
                <textarea placeholder="내용을 입력해 주세요" onChange={(e) => {valInsert('contents', e.target.value)}}></textarea>
              </div>
              <DropFileZone fileDatas={value.images} handleFile={setValue} />
              <div className="btns_wrap mt_50 mb_50">
                <Link className="font_style1 btn_play application" onClick={() => Insert('/inquiry/add', value, setDataLoading, () => {navigate("/myPage/inquery")})}>문의 등록</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

